module.exports = __webpack_public_path__ + "static/img/yi_xiao.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/yi_xiao.jpg
// module id = GO9L
// module chunks = 0